import { get, BaseUrl, put, post } from './api';

export const getDashboard = async () => {
    return await get(`api/Dashboard/Dashboard`, null,
        BaseUrl.Centerpoint);
}